import {Injectable} from "@angular/core";
import {ParameterRule} from "@ispm-client/modules/query-builder/models/query-builder-config";
import {FactorBaseService} from "./factor-base-service";

@Injectable()
export class LabTestService extends FactorBaseService{
  static readonly NAME = "name";
  static readonly VALUE = "value";
  static readonly UNITS = "units";
  static readonly RESULT = "result";
  static readonly CHANGE = "change";
  static readonly HYPHEN = "-";


  public getDisplayName(parameterRule: ParameterRule) : string {
    //create a dictionary of Rules where the attribute type is the key (e.g., gene, origin)
    this.parameterRulesMap = {};
    let parameterRules = parameterRule.rules;
    for (let rule of parameterRules) {
      this.parameterRulesMap[rule.field.toLowerCase()] = rule;
    }

    //get lab test type
    let parameter: string = parameterRule.parameter.toLowerCase();
    let labTestType: string = "";
    switch (parameter.toLowerCase()) {
      case "labtest": {
        labTestType = this.labTest();
        break;
      }
    }
    return labTestType;
  }

  private labTest(): string {
    /*
    Lab Test
    {Name}
    {Value}{Units}
    {Result}
    {Change}
     */
    var results: string[] = new Array();

    this.name(results);
    this.value(results);
    this.result(results);
    this.change(results);

    let delimitedString = results.join(LabTestService.SPACE);
    return delimitedString;
  }

  private name(results: string[]) {
    let rule = this.parameterRulesMap[LabTestService.NAME];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results);
    }
  }

  private value(results: string[]) {
    let rule = this.parameterRulesMap[LabTestService.VALUE];
    if (rule) {
      let displayValue: string = rule.value;
      this.pushWithOperator(rule, displayValue, results);
      this.units(results);
    }
  }

  private units(results: string[]) {
    let rule = this.parameterRulesMap[LabTestService.UNITS];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results);
    }
  }

  private result(results: string[]) {
    let rule = this.parameterRulesMap[LabTestService.RESULT];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results);
    }
  }

  private change(results: string[]) {
    let rule = this.parameterRulesMap[LabTestService.CHANGE];
    if (rule) {
      let displayValue: string = rule.value.display;
      this.pushWithOperator(rule, displayValue, results);
    }
  }

}
